/* ============================================================
   SAVIRENA / LullaBites — Interacciones (vanilla, sin librerías)
   ============================================================ */
(function () {
  "use strict";
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Reveals al hacer scroll ---------- */
  function initReveal(root) {
    root = root || document;
    var items = root.querySelectorAll(".sr-reveal:not(.sr-in)");
    if (!items.length) return;
    if (reduceMotion || !("IntersectionObserver" in window)) {
      items.forEach(function (el) { el.classList.add("sr-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          var d = el.getAttribute("data-sr-delay");
          if (d) el.style.setProperty("--sr-delay", d + "ms");
          el.classList.add("sr-in");
          io.unobserve(el);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Grupos con stagger automático ---------- */
  function initStagger(root) {
    root = root || document;
    root.querySelectorAll("[data-sr-stagger]").forEach(function (group) {
      var step = parseInt(group.getAttribute("data-sr-stagger"), 10) || 90;
      var kids = group.querySelectorAll(".sr-reveal");
      kids.forEach(function (el, i) { el.setAttribute("data-sr-delay", i * step); });
    });
  }

  /* ---------- Cielo estrellado (canvas) ---------- */
  function initStars(root) {
    root = root || document;
    root.querySelectorAll(".sr-stars[data-stars]").forEach(function (host) {
      if (host.dataset.srInit) return;
      if (host.dataset.srGl === "1") return;
      host.dataset.srInit = "1";
      var canvas = document.createElement("canvas");
      host.appendChild(canvas);
      var ctx = canvas.getContext("2d");
      var stars = [], w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
      var density = parseFloat(host.getAttribute("data-stars")) || 1;

      function resize() {
        var r = host.getBoundingClientRect();
        w = Math.max(1, r.width); h = Math.max(1, r.height);
        canvas.width = w * dpr; canvas.height = h * dpr;
        canvas.style.width = w + "px"; canvas.style.height = h + "px";
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var count = Math.round((w * h) / 9000 * density);
        stars = [];
        for (var i = 0; i < count; i++) {
          stars.push({
            x: Math.random() * w, y: Math.random() * h,
            r: Math.random() * 1.3 + 0.3,
            base: Math.random() * 0.5 + 0.3,
            amp: Math.random() * 0.5 + 0.2,
            sp: Math.random() * 0.9 + 0.25,
            ph: Math.random() * Math.PI * 2,
            gold: Math.random() > 0.82
          });
        }
      }
      function draw(t) {
        ctx.clearRect(0, 0, w, h);
        for (var i = 0; i < stars.length; i++) {
          var s = stars[i];
          var a = s.base + s.amp * Math.sin(t * 0.001 * s.sp + s.ph);
          if (a < 0) a = 0;
          ctx.globalAlpha = a;
          ctx.fillStyle = s.gold ? "#E6B566" : "#F6F1E9";
          ctx.beginPath();
          ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.globalAlpha = 1;
      }
      var raf;
      function loop(t) { draw(t); raf = requestAnimationFrame(loop); }
      resize();
      if (reduceMotion) { draw(0); }
      else { raf = requestAnimationFrame(loop); }
      var rt;
      window.addEventListener("resize", function () {
        clearTimeout(rt); rt = setTimeout(function () { resize(); if (reduceMotion) draw(0); }, 200);
      });
    });
  }

  /* ---------- Contadores ---------- */
  function initCount(root) {
    root = root || document;
    var nums = root.querySelectorAll("[data-count]:not([data-count-done])");
    if (!nums.length) return;
    if (reduceMotion || !("IntersectionObserver" in window)) {
      nums.forEach(function (el) { el.textContent = el.getAttribute("data-count-prefix") ? el.getAttribute("data-count-prefix") + el.getAttribute("data-count") : el.getAttribute("data-count") + (el.getAttribute("data-count-suffix") || ""); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; el.setAttribute("data-count-done", "1"); io.unobserve(el);
        var target = parseFloat(el.getAttribute("data-count"));
        var suffix = el.getAttribute("data-count-suffix") || "";
        var prefix = el.getAttribute("data-count-prefix") || "";
        var dec = (el.getAttribute("data-count") + "").indexOf(".") > -1 ? 1 : 0;
        var dur = 1500, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = prefix + (target * eased).toFixed(dec) + suffix;
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = prefix + target.toFixed(dec) + suffix;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (el) { io.observe(el); });
  }

  /* ---------- FAQ acordeón ---------- */
  function initFaq(root) {
    root = root || document;
    root.querySelectorAll(".sr-faq-q:not([data-srf])").forEach(function (btn) {
      btn.setAttribute("data-srf", "1");
      btn.addEventListener("click", function () {
        var item = btn.closest(".sr-faq-item");
        var ans = item.querySelector(".sr-faq-a");
        var open = item.classList.contains("sr-open");
        var group = btn.closest("[data-faq-group]");
        if (group && !open) {
          group.querySelectorAll(".sr-faq-item.sr-open").forEach(function (it) {
            it.classList.remove("sr-open");
            it.querySelector(".sr-faq-a").style.maxHeight = null;
            it.querySelector(".sr-faq-q").setAttribute("aria-expanded", "false");
          });
        }
        item.classList.toggle("sr-open");
        btn.setAttribute("aria-expanded", open ? "false" : "true");
        ans.style.maxHeight = open ? null : ans.scrollHeight + "px";
      });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGallery(root) {
    root = root || document;
    root.querySelectorAll(".sr-gallery:not([data-srg])").forEach(function (g) {
      g.setAttribute("data-srg", "1");
      var main = g.querySelector(".sr-gallery__main img");
      g.querySelectorAll(".sr-gallery__thumb").forEach(function (th) {
        th.addEventListener("click", function () {
          var src = th.getAttribute("data-full");
          if (main && src) { main.src = src; }
          g.querySelectorAll(".sr-gallery__thumb").forEach(function (x) { x.classList.remove("sr-active"); });
          th.classList.add("sr-active");
        });
      });
    });
  }

  /* ---------- Selector de cantidad ---------- */
  function initQty(root) {
    root = root || document;
    root.querySelectorAll(".sr-qty:not([data-srq])").forEach(function (q) {
      q.setAttribute("data-srq", "1");
      var input = q.querySelector("input");
      var minus = q.querySelector("[data-qm]");
      var plus = q.querySelector("[data-qp]");
      function clamp() { var v = parseInt(input.value, 10); if (isNaN(v) || v < 1) v = 1; input.value = v; }
      if (minus) minus.addEventListener("click", function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); clamp(); });
      if (plus) plus.addEventListener("click", function () { input.value = (parseInt(input.value, 10) || 1) + 1; clamp(); });
      input.addEventListener("change", clamp);
    });
  }

  /* ---------- Carrusel de catálogo ---------- */
  function initCarousel(root) {
    root = root || document;
    root.querySelectorAll("[data-sr-carousel]:not([data-src])").forEach(function (wrap) {
      wrap.setAttribute("data-src", "1");
      var track = wrap.querySelector(".sr-carousel");
      var prev = wrap.querySelector("[data-car-prev]");
      var next = wrap.querySelector("[data-car-next]");
      if (!track) return;
      function amt() { var card = track.querySelector(".sr-pcard"); return card ? card.offsetWidth + 20 : 260; }
      if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -amt(), behavior: "smooth" }); });
      if (next) next.addEventListener("click", function () { track.scrollBy({ left: amt(), behavior: "smooth" }); });
    });
  }

  /* ---------- Inclinación 3D con el ratón ---------- */
  function initTilt(root) {
    root = root || document;
    if (reduceMotion || !window.matchMedia || !window.matchMedia("(hover: hover)").matches) return;
    root.querySelectorAll("[data-sr-tilt]:not([data-srt])").forEach(function (zone) {
      zone.setAttribute("data-srt", "1");
      var el = zone.querySelector(".sr-tilt") || zone;
      var max = parseFloat(zone.getAttribute("data-sr-tilt")) || 8;
      zone.addEventListener("mousemove", function (e) {
        var r = zone.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty("--sr-ry", (px * max).toFixed(2) + "deg");
        el.style.setProperty("--sr-rx", (-py * max).toFixed(2) + "deg");
      });
      zone.addEventListener("mouseleave", function () {
        el.style.setProperty("--sr-ry", "0deg");
        el.style.setProperty("--sr-rx", "0deg");
      });
    });
  }

  /* ---------- Init global ---------- */
  function boot(root) {
    initStagger(root);
    initReveal(root);
    initStars(root);
    initCount(root);
    initFaq(root);
    initGallery(root);
    initQty(root);
    initCarousel(root);
    initTilt(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); });
  } else { boot(document); }

  /* Editor de Shopify: reinicializa al añadir/recargar secciones */
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
  document.addEventListener("shopify:section:select", function (e) { boot(e.target); });
})();
